// removed by extract-text-webpack-plugin
module.exports = {"root":"initial-organization-selector--root--3yAZrgwF","content":"initial-organization-selector--content--3boGf9uV","title":"initial-organization-selector--title--FK0xxTEx","organization":"initial-organization-selector--organization--I3_olwoK","button":"initial-organization-selector--button--Nll-iEWN"};


//////////////////
// WEBPACK FOOTER
// ./components/initial-organization-selector/styles.css
// module id = ./components/initial-organization-selector/styles.css
// module chunks = 0